const breakPoint = 767;
let resizeFlag   = false;
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
let windowWidthJ = $(window).width();





// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  $("a[href^=#]").on("click", function(){
    var linkSpeed    = 800;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 0;
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    return false;
  });
};

// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const stepSlider = () => {
  $('.idx-Slider_Inner').slick({
    // アクセシビリティ。左右ボタンで画像の切り替えをできるかどうか
    accessibility: true,
    // 自動再生。trueで自動再生される。
    autoplay: false,
    // 自動再生や左右の矢印でスライドするスピード
    speed: 500,
    // 自動再生時にスライドのエリアにマウスオンで一時停止するかどうか
    pauseOnHover: true,
    // 自動再生時にドットにマウスオンで一時停止するかどうか
    pauseOnDotsHover: true,
    // 切り替えのアニメーション。ease,linear,ease-in,ease-out,ease-in-out
    cssEase: 'ease',
    // 画像下のドット（ページ送り）を表示
    dots: true,
    // ドットのclass名をつける
    dotsClass: 'slick-dots',
    // ドラッグができるかどうか
    draggable: true,
    // 切り替え時のフェードイン設定。trueでon
    fade: false,
    // 左右の次へ、前へボタンを表示するかどうか
    arrows: true,
    // 無限スクロールにするかどうか。最後の画像の次は最初の画像が表示される。
    infinite: false,
    // 最初のスライダーの位置
    initialSlide: 0,
    // 画像の遅延表示。‘ondemand’or'progressive'
    lazyLoad: 'ondemand',
    // スライドのエリアにマウスオーバーしている間、自動再生を止めるかどうか。
    pauseOnHover: true,
    // スライドのエリアに画像がいくつ表示されるかを指定
    slidesToShow: 1,
    // 一度にスライドする数
    slidesToScroll: 1,
    // タッチスワイプに対応するかどうか
    swipe: true,
    // 縦方向へのスライド
    vertical: false,
    // 表示中の画像を中央へ
    centerMode: true,
    variableWidth: true,
    prevArrow: '<a class="slick-prev" href="#"></a>',
    nextArrow: '<a class="slick-next" href="#"></a>',

  });
};

// ------------------------------------------------------------------------
// visibleButton
// ----- BOTH
// ------------------------------------------------------------------------
const visibleButton = () => {
  let targetButton = document.querySelector('.sw-Top');
  let targetHeight = 100;
  window.addEventListener('scroll', () => {
    let scrollHeight = window.pageYOffset;
    if (scrollHeight > targetHeight) {
      targetButton.classList.remove('is-Hidden');
    } else {
      targetButton.classList.add('is-Hidden');
    }
  });
}





export {
  anchorLink,
  stepSlider,
  visibleButton
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js